import { render, staticRenderFns } from "./Cars.vue?vue&type=template&id=b2b253d8&scoped=true"
import script from "./Cars.vue?vue&type=script&lang=js"
export * from "./Cars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b253d8",
  null
  
)

export default component.exports